export function isJapanLocale(locale: string): boolean {
    const key = locale.trim().replace(/-/g, '_').toLowerCase();
    return key === 'ja_jp' || key === 'ja';
}
